import { FaqSection } from "@gromia/components/landing/FaqSection";
import { Quote } from "@gromia/components/landing/Quote";
import { Statistic, Statistics } from "@gromia/components/landing/Statistics";
import {
  VerticalMarketingStep,
  VerticalMarketingSteps,
  VerticalStepContent,
  VerticalStepImage,
} from "@gromia/components/landing/VerticalMarketingSteps";
import * as s from "@gromia/components/theme/t.module.css";
import { LinkButton } from "@gromia/components/ui/Button";
import { Carousel } from "@gromia/components/ui/Carousel";
import { Hero } from "@gromia/components/ui/HeroFast";
import { HeroLandingContent } from "@gromia/components/ui/HeroLandingContent";
import { Layout } from "@gromia/components/ui/Layout";
import { Text } from "@gromia/components/ui/Text";
import { Contacts } from "@gromia/pages/_Contacts";
import { Seo } from "@gromia/Seo";
import strings from "@gromia/strings/landingSwitch";
import { useParams } from "@gromia/utils/useParams";
import { useString } from "@gromia/utils/useString";
import cx from "classnames";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";

function Page() {
  const { tx, raw } = useString("landingSwitch", strings);
  const p = useParams();
  const cta = p.linkWithTracking("/cambia/form");

  const ctaButton = (
    <div className={s.spaceTop2}>
      <LinkButton color="btnCta" to={cta}>
        {tx("cta")}
      </LinkButton>
    </div>
  );

  return (
    <React.Fragment>
      <Seo title={raw("seoTitle")} description={raw("seoDescription")} />
      <Hero
        image={() => (
          <StaticImage
            src="./images/hero-cambia-casa.jpg"
            alt=""
            className={Hero.imageClass}
          />
        )}
      >
        <HeroLandingContent
          title1={tx("title1")}
          title2={tx("title2")}
          ctaHref={cta}
          layout="60"
          cta={tx("cta")}
        />
      </Hero>
      <section
        className={cx(
          s.bgWhite,
          s.textCenter,
          s.positionRelative,
          s.space2,
          s.textBody,
        )}
      >
        <div className={cx(s.container)}>
          <Text tag="p" s="pill">
            {tx("stepperPill")}
          </Text>
          <Text tag="h2" s="title">
            {tx("stepperTitle")}
          </Text>
          <Text tag="p" s="titleSmall">
            {tx("stepperText")}
          </Text>
          <div className={s.spaceTop1} />
          <VerticalMarketingSteps>
            <VerticalMarketingStep
              main={
                <VerticalStepContent
                  title={tx("stepper1title")}
                  text={tx("stepper1text")}
                />
              }
              side={
                <VerticalStepImage src={require("./images/1.svg").default} />
              }
            />
            <VerticalMarketingStep
              main={
                <VerticalStepContent
                  title={tx("stepper2title")}
                  text={tx("stepper2text")}
                />
              }
              side={
                <VerticalStepImage src={require("./images/2.svg").default} />
              }
            />
            <VerticalMarketingStep
              main={
                <VerticalStepContent
                  title={tx("stepper3title")}
                  text={tx("stepper3text")}
                />
              }
              side={
                <VerticalStepImage src={require("./images/3.svg").default} />
              }
            />
            <VerticalMarketingStep
              main={
                <VerticalStepContent
                  title={tx("stepper4title")}
                  text={tx("stepper4text")}
                />
              }
              side={
                <VerticalStepImage src={require("./images/4.svg").default} />
              }
            />
            <VerticalMarketingStep
              main={
                <VerticalStepContent
                  title={tx("stepper5title")}
                  text={tx("stepper5text")}
                />
              }
              side={
                <VerticalStepImage src={require("./images/5.svg").default} />
              }
            />
            <VerticalMarketingStep
              main={
                <VerticalStepContent
                  title={tx("stepper6title")}
                  text={tx("stepper6text")}
                />
              }
              side={
                <VerticalStepImage src={require("./images/6.svg").default} />
              }
            />
          </VerticalMarketingSteps>
          {ctaButton}
        </div>
      </section>
      <section
        className={cx(s.bgLight1, s.space2, s.textCenter, s.positionRelative)}
      >
        <div className={cx(s.container)}>
          <Text tag="p" s="pill">
            {tx("testimonialsPill")}
          </Text>
          <Text tag="h2" s="title">
            {tx("testimonialsTitle")}
          </Text>
          <Text tag="p" s="titleSmall">
            {tx("testimonialsText")}
          </Text>
          <div className={s.space1}>
            <Carousel
              options={{
                perPageXs: 1,
                perPageSm: 1,
                perPageMd: 1,
                perPageLg: 2,
                perPageXl: 2,
              }}
            >
              <Quote
                line1={tx("quote11")}
                line2={tx("quote12")}
                line3={tx("quote13")}
              />
              <Quote
                line1={tx("quote21")}
                line2={tx("quote22")}
                line3={tx("quote23")}
              />
            </Carousel>
          </div>
        </div>
      </section>
      <section className={cx(s.bgPrimaryDarker)}>
        <div className={cx(s.textCenter, s.spaceTop2)}>
          <Text tag="p" s="pill" inverted>
            {tx("ourNumbersPill")}
          </Text>
          <Text tag="h2" s="title" inverted>
            {tx("ourNumbersTitle")}
          </Text>
        </div>
        <Statistics>
          <Statistic stat={tx("stat1")} sub={tx("stat1Sub")} />
          <Statistic stat={tx("stat2")} sub={tx("stat2Sub")} />
          <Statistic stat={tx("stat3")} sub={tx("stat3Sub")} />
        </Statistics>
      </section>
      <FaqSection useStringKey="landingSwitch" strings={strings} />
      <Contacts />
    </React.Fragment>
  );
}

export default () => (
  <Layout>
    <Page />
  </Layout>
);
